import { createFileRoute } from '@tanstack/react-router';

import { RetrospectivesPage } from '../../features/manager-retrospectives/components/RetrospectivesPage';

export const Route = createFileRoute('/_onboarding/retrospectives')({
  component: RetrospectivesRoute,
});

function RetrospectivesRoute() {
  return <RetrospectivesPage />;
}
